<template>
  <div data-controller="navigator">
    <p class="fw-semibold">{{ $t('manual_geolocation.title') }}</p>
    <div class="d-flex flex-column mt-2 mb-2 gap-1">
      <form class="flex-fill w-100">
        <div class="" data-navigator-target="correctInput">
          <input ref="addressInput" class="form-control pac-target-input" :placeholder="$t('manual_geolocation.address_input_placeholder')" name="formatted_address" autocomplete="off">
          <div class="d-flex gap-2 mt-3 mb-2">
            <button @click="correctGeolocation" :disabled="!addressFilled" :class="{ disabled: !addressFilled }" name="button" class="btn btn-primary flex-fill">{{ $t('manual_geolocation.save_btn_content') }}</button>
            <button @click="cancelManuelGeolocation" name="button" type="button" class="btn btn-outline-primary flex-fill" data-action="click->navigator#uncorrectPosition">{{ $t('manual_geolocation.cancel_btn_content') }}</button>
          </div>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  import { loadGoogleMapFrontApi, isNullOrUndefined, setWithDefault, sendAcCommand } from '@lib/utilities'

  export default {
    data() {
      return {
        autocomplete: null,
        addressFilled: false,
        addressData: null
      }
    },
    props: {
      userActivity: Object,
      subscription: Object,
      modifyingGeolocation: Boolean,
      event: {
        type: String,
        default: 'correct'
      }
    },
    mounted() {
      loadGoogleMapFrontApi();
      this.initAutocomplete()
    },
    methods: {
      async initAutocomplete() {
        const autocompleteInput = this.$refs.addressInput;
        if (isNullOrUndefined(autocompleteInput)) {
          return;
        }

        const { Autocomplete } = await google.maps.importLibrary("places");

        this.autocomplete = new Autocomplete(autocompleteInput, {
          componentRestrictions: { country: ['fr'] },
          fields: ['address_components', 'geometry', 'icon', 'name'],
          types: ['address']
        });
        this.autocomplete.addListener('place_changed', this.fillInAddress);
      },
      fillInAddress() {
        const place = this.autocomplete.getPlace();
        const latitude = place.geometry.location.lat();
        const longitude = place.geometry.location.lng();
        const address = this.formatGoogleAddress(place.address_components)
        this.addressData = {
          latitude: latitude,
          longitude: longitude,
          country: address.country,
          number: address.street_number,
          street_name: setWithDefault(address.route, address.street_address),
          city_name: address.locality,
          city_zip: address.postal_code
        }

        this.addressFilled = true;
      },
      formatGoogleAddress(googleAddress) {
        return googleAddress
                .filter((item) => {
                  return item.types.find((type) => {
                    return type === 'street_number' || type === 'street_address' || type === 'route' || type === 'locality' || type === 'country' || type === 'postal_code'
                  })
                })
                .map((item) => {
                  return [item.types[0], item.long_name]
                })
                .reduce((result, item) => {
                  result[item[0]] = item[1];
                  return result
                }, {});
      },
      correctGeolocation(event) {
        event.preventDefault();

        if(!this.addressFilled || isNullOrUndefined(this.addressData)) {
          return;
        }
        const params = { id: this.userActivity.id, event: this.event, ...this.addressData }

        sendAcCommand(this.subscription, 'update_beneficiary_geolocation', params)
      },
      cancelManuelGeolocation() {
        this.$emit('update:modifyingGeolocation', false);
      }
    }
  };
</script>
